import React from 'react';
import {
  Box,
  Typography,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { IMissionDetail } from '../../../api/types';
import moment from 'moment';

interface MissionDetailProps {
  data: IMissionDetail;
  onBack: () => void;
}

const MissionDetail = ({ data, onBack }: MissionDetailProps) => {
  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <IconButton onClick={onBack} sx={{ mb: 2 }}>
          <ArrowBack />
        </IconButton>
        
        <Typography variant="h5" sx={{ mb: 3 }}>
          Mission History
        </Typography>
      </Box>

      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Performance Score</TableCell>
                {/*<TableCell>Effort Score</TableCell>*/}
                {/*<TableCell>Challenge Score</TableCell>*/}
                {/*<TableCell>Total Score</TableCell>*/}
                <TableCell>Time</TableCell>
                <TableCell align="right">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.data.history.map((record, index) => (
                <TableRow key={record.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{record.performance_score}</TableCell>
                  {/*<TableCell>{record.effort_score}</TableCell>*/}
                  {/*<TableCell>{record.challenge_score}</TableCell>*/}
                  {/*<TableCell>{record.total_score}</TableCell>*/}
                  <TableCell>
                    {moment.utc(record.created_at).local().format('YYYY-MM-DD HH:mm:ss')}
                  </TableCell>
                  <TableCell align="right">
                    <Button
                      variant="contained"
                      size="small"
                      href={`${process.env.URL_DIGITAL_TWIN_REPLAY}?replay=${record.mission_run_id}`}
                      target="_blank"
                    >
                      View Replay
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
};

export default MissionDetail; 